<script>
	import { tick } from "svelte";

	import model from "../../stores/modelStore";
	import lookups from "../../stores/lookupStore";
	import { registerPageComplete } from "../../tealium";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";

	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import Select from "../../components/Select.svelte";
	import TextInput from "../../components/TextInput.svelte";
	import TextArea from "../../components/TextArea.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import AddButton from "../../components/buttons/AddButton.svelte";
	import DeleteButton from "../../components/buttons/DeleteButton.svelte";
	import ChildCareCentre from "./components/ChildCareCentre.svelte";

	// props
	export let persistUrl = null;
	export let pageName = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}
	console.log($lookups);
	if (!$model.claimDetails.childCareCentres || !$model.claimDetails.childCareCentres.length) {
		$model.claimDetails.childCareCentres = [{}];
	}

	let buttons = null;

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	let otherRelationshipId = $lookups.relationshipWithChild.filter((m) => m.label == "Other")[0].value;
</script>

<PageSection>
	<Form {disabled} id="form-claim-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Claim Details</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<ChildCareCentre bind:childCareCentres={$model.claimDetails.childCareCentres} {disabled} />
		</div>

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<YesNoGroup
						required
						{disabled}
						name="stiTesting"
						label="Have you been directed by the police or state department to undergo STI testing?"
						bind:value={$model.claimDetails.stiTesting} />
				</FormColumn>
			</FormRow>

			<FormRow class="align-items-end">
				<FormColumn>
					<Select
						required
						{disabled}
						label="What is your relationship to the child?"
						optionList={$lookups.relationshipWithChild}
						textProperty="label"
						valueProperty="value"
						bind:value={$model.claimDetails.relationshipWithChildId} />
				</FormColumn>
			</FormRow>

			{#if $model.claimDetails.relationshipWithChildId == otherRelationshipId}
				<FormRow class="align-items-end">
					<FormColumn>
						<TextInput
							required
							{disabled}
							label="What is your relationship to the child?"
							bind:value={$model.claimDetails.relationshipWithChildOther}
							maxlength="250" />
					</FormColumn>
				</FormRow>
			{/if}

			<FormRow>
				<FormColumn>
					<TextArea
						{disabled}
						label="Additional Information"
						bind:value={$model.claimDetails.additionalInformation} />
				</FormColumn>
			</FormRow>

			<FormRow class="confirmation-hide">
				<FormColumn>
					<NavigationButtons bind:buttons />
				</FormColumn>
			</FormRow>
		</div></Form>
</PageSection>
